export default {
  NOT_FOUND: '/not-found',
  LOGIN: '/login',
  SFTP: '/'
};
